import { Component, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddDeleteComponent } from '../add-delete/add-delete.component';
import { FormBuilder } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { CostsavingdetailsService } from "../../../../services/costsavingdetails.service";
import { DoublingEditorComponent } from '../doubling-editor.component';
import { MSolutionType } from "../../../../enum/MSolutionType";
import { MExpenseType } from "../../../../enum/MExpenseType";
import { ToasterService } from 'src/app/services/toaster.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { NumericEditorComponent } from '../numeric-editor.component';
import 'ag-grid-enterprise';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { AlertDialogComponent } from '../../../../alert-dialog/alert-dialog.component';
import { serverMessage } from '../../../../popUpMessages/serverMessage';
import { messages } from '../../../../popUpMessages/messages';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { Dirty } from 'src/app/interface/dirty-interface';
import { EnumRemarkType } from 'src/app/enum/EnumRemarkType';
import { IdeaformService } from 'src/app/services/ideaform.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { CategorizationService } from 'src/app/services/categorization.service';

//Defined Global variables
let countryCode;

@Component({
  selector: 'app-option-b',
  templateUrl: './option-b.component.html',
  styleUrls: ['./option-b.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class OptionBComponent implements Dirty {

  //Bind Form
  dataBind = [];
  public costType: any[] = [{ CostTypeId: 0, CostTypeTitle: "Please select" }];
  public formData = {};
  public responsePost: any;
  public errorMessageApi = [];
  public loginUserDetails: any;
  public submitted: boolean = false;

  //Bind Variables
  public refCostGridApi: any;
  public tgtCostGridApi: any;

  public optionBCostGridApi: any;
  public gridColumnApi: any;

  public optionBColumnDefs: any;
  public defaultColDef: any;
  public autoGroupOptionBCostColumnDef: any;

  public optionBCostRowData: any;
  public newItemCount: any;
  public rowSelection: any;
  public domLayout: any;
  public rowData: any;
  public showGrid = false;
  public frameworkComponents;
  public savingsVSreferenceValue: any = 0;
  public hasUnsavedChanges: boolean = false;

  //Remarks Variables
  public RemarksId: any;
  public Remarks: string = null;
  public ideaId: number;

  //Variable with values
  public oneTimeCostHeaderName: string = "One time costs/ Process costs";
  public recurringExpHeaderName: string = "Recurring Expenses";
  public arrayOptBGridData = [];
  public isChangeRemarks: any;
  public isChangeinOptBGrid: boolean = false;
  public arrayDelOptBGridData = [];
  public isEditable: boolean = false;

  public businessAreaId: number = 0;
  public businessLineId: number = 0;
  public allUserList: any;
  public userInOrg: any;

  //Savings versus reference scenario Variables
  public refRowData = [];
  public arraySavNRefCal = [];
  public RefOneTimeCostTotal: any = 0;

  //Bind constructor
  constructor(
    private http: HttpClient,
    public fb: FormBuilder,
    public dialog: MatDialog,
    private ToasterService: ToasterService,
    private CostsavingdetailsService: CostsavingdetailsService,
    private LocalStorageService: LocalStorageService,
    private sharedService: SharedServiceService,
    private router: Router,
    private menuService: MenuService,
    private ideaService: IdeaformService,
    private userService: UserInfoService,
    private catService: CategorizationService
  ) {
  }

  ngOnInit(): void {

    //Get current loging user details
    this.sharedService.loggedInUser.subscribe(
      (user) => {
        this.loginUserDetails = user;
      }
    );

    this.sharedService.getIdeaIdAndtitle();

    //Get IdeaId
    this.ideaId = this.LocalStorageService.get('ideaId');

    //Get Country Code

    countryCode = this.LocalStorageService.get('countryCode');

    this.isEditable = false;
    this.ideaService.getData(this.ideaId).subscribe((data: any) => {
      if (data.StatusCode == 200) {
        this.businessAreaId = data.Data.BusinessAreaId;
        this.businessLineId = data.Data.BusinessLineId;
        
        this.sharedService.loggedInUser.subscribe((user: any) => {
          this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d: any) => {
            this.allUserList = d;
            this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
            if (this.userInOrg != undefined) {

              if (this.userInOrg.RoleId == 1 || this.userInOrg.RoleId == 2) {
                this.isEditable = true;
                this.pageLock(this.ideaId, this.businessAreaId, this.businessLineId);
              }
              else if (this.userInOrg.RoleId == 3) {
                if (data.Data.SubmitterId == this.userInOrg.UserId) {
                  this.isEditable = true;
                  this.pageLock(this.ideaId, this.businessAreaId, this.businessLineId);
                }
                else {
                  this.isEditable = false;
                }
              }
              //Load Ag-Grid data
              this.loadMasterData(this.businessAreaId, this.businessLineId);
            }
          })
        })
      }
    })
  }

  pageLock(ideaId, businessAreaId, businessLineId) {
    this.catService.getPageLockStatus(ideaId, businessAreaId, businessLineId).subscribe(data => {
      let errorMsgeFromBack = data.Data.Message;
      let pageLockMessage = "";
      if (data.StatusCode == 200) {
        this.isEditable = data.Data.Status;
        pageLockMessage = data.Data.Message;
        if(pageLockMessage != ""){
          this.openAlertDialog([{ [pageLockMessage]: serverMessage.warning }]);
        }
      }
      else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer)
      }
    }, (error) => {
      //Show errorCode and errorMessage in the UI
      this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
    });
  }

  canDeactivate() {
    return this.hasUnsavedChanges;
  }

  loadMasterData(areaId, lineId) {
    this.CostsavingdetailsService.getCostType(areaId, lineId).subscribe((data: any) => {
      let errorMsgeFromBack = data.Data.Message;
      if (data.StatusCode == 200) {
        let responseData;
        responseData = data;
        responseData.Data.forEach(element => {
          this.costType.push({ CostTypeId: element.CostTypeId, CostTypeTitle: element.CostTypeTitle });
        });

        //Option B ag-Grid data
        this.bindOptionBGridData();
      }
      else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer)
      }
    }, (error) => {
      // this.sharedService.getErrorMessage(error);
      //Show errorCode and errorMessage in the UI
      this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
    });
  }

  //Load ag-Grid 
  loadAgGrid() {

    //Bind ag-grids
    this.showGrid = true;

    this.optionBColumnDefs = [
      {
        field: 'agGridId',
        hide: true,
      },
      {
        field: 'CostSavingDetailId',
        hide: true,
      },
      {
        field: 'tgtCostHeader',
        rowGroup: true,
        hide: true,
        width: 100,
        suppressSizeToFit: true
      },
      {
        headerName: "Cost Type",
        headerTooltip: "Cost Type",
        field: 'CostType',
        tooltipField: 'CostType',
        hide: true,
        suppressSorting: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: this.costType.map(x => x.CostTypeTitle),
          cellRenderer: function (params) {
            return params.value.CostTypeId;
          }
        },

        singleClickEdit: true,
        width: 80,
        suppressSizeToFit: true,
        // cellStyle: cellStyle,
      },
      {
        headerName: 'Labour Rate',
        headerTooltip: "Labour Rate",
        field: 'LabourRate',
        //tooltipField: 'LabourRate',
        tooltipValueGetter: CurrencyCellRenderer,
        cellEditor: 'doublingEditor',
        cellRenderer: CurrencyCellRenderer,
        singleClickEdit: true,
      },
      {
        headerName: 'Effort(hrs per unit)',
        field: 'Effort',
        headerTooltip: "Effort(hrs per unit)",
        //tooltipField: 'Effort',
        tooltipValueGetter: CurrencyCellRenderer,
        cellEditor: 'doublingEditor',
        aggFunc: function (data: any) {
          let sum = 0;
          data.forEach(function (value: any) {
            if (value) {
              sum = sum + parseFloat(value);
            }
          });
          if (!sum) { return null; }
          return sum;
        },
        cellRenderer: CurrencyCellRenderer,
        singleClickEdit: true,
      },
      {
        headerName: 'Total Effort',
        field: 'TotalEffort',
        headerTooltip: "Total Effort",
        //tooltipField: 'TotalEffort',
        tooltipValueGetter: CurrencyCellRenderer,
        editable: false,
        valueGetter: funTotalEffort,
        cellStyle: { 'background-color': '#cccccc' },
        aggFunc: function (data: any) {
          let sum = 0;
          data.forEach(function (value: any) {
            if (value) {
              sum = sum + parseFloat(value);
            }
          });
          if (!sum) { return null; }
          return sum;
        },
        cellRenderer: CurrencyCellRenderer
      },
      {
        headerName: 'Costs abs. per unit',
        headerTooltip: "Costs abs. per unit",
        field: 'CostsUnit',
        //tooltipField: 'CostsUnit',
        tooltipValueGetter: CurrencyCellRenderer,
        cellEditor: 'doublingEditor',
        aggFunc: function (data: any) {
          let sum = 0;
          data.forEach(function (value: any) {
            if (value) {
              sum = sum + parseFloat(value);
            }
          });
          if (!sum) { return null; }
          return sum;
        },
        cellRenderer: CurrencyCellRenderer,
        singleClickEdit: true,

      },
      {
        headerName: 'Total',
        field: 'Total',
        headerTooltip: "Total",
        //tooltipField: 'Total',
        tooltipValueGetter: CurrencyCellRenderer,
        editable: false,
        valueGetter: funTotal,
        cellStyle: { 'background-color': '#cccccc' },
        aggFunc: function (data: any) {
          let sum = 0;
          data.forEach(function (value: any) {
            if (value) {
              sum = sum + parseFloat(value);
            }
          });
          if (!sum) { return null; }
          return sum;
        },
        cellRenderer: CurrencyCellRenderer
      },
      {
        headerName: 'Affected units',
        field: 'AffectedUnits',
        headerTooltip: "Affected Units",
        //tooltipField: 'AffectedUnits',
        tooltipValueGetter: CurrencyCellRenderer,
        cellStyle: cellStyle1,
        cellEditor: 'NumericEditor',
        cellRenderer: CurrencyCellRenderer,
        singleClickEdit: true,
        editable: params => {
          if (params.data.tgtCostHeader == this.oneTimeCostHeaderName) {
            return false;
          }
          else {
            if (this.isEditable) {
              return true;
            }
            else {
              return false;
            }
          }
        }
      },
      {
        field: 'TotalCostAcc',
        headerTooltip: "Total Cost Acc",
        valueGetter: funTotalCost,
        editable: false,
        //tooltipField: 'TotalCostAcc',
        tooltipValueGetter: CurrencyCellRenderer,
        cellStyle: { 'background-color': '#cccccc' },
        aggFunc: function (data: any) {
          let sum = 0;
          data.forEach(function (value: any) {
            if (value) {
              sum = sum + parseFloat(value);
            }
          });
          if (!sum) { return null; }
          return sum;
        },
        cellRenderer: CurrencyCellRenderer
      },
      {
        headerName: "Action",
        headerTooltip: "Action",
        filter: false,
        editable: false,
        cellRendererFramework: AddDeleteComponent,
        colId: "edit",
        sortable: false,
        width: 50,
        suppressSizeToFit: true
      },
    ]

    this.rowSelection = 'single';
    this.defaultColDef = {
      /*  flex: 1, */
      suppressMovable: true,
      sortable: false,
      // wrapText: true,
      editable: this.isEditable
    };

    this.autoGroupOptionBCostColumnDef = {
      headerName: 'Cost Items',
      headerTooltip: "Cost Items",
      field: 'tgtCostTitle',
      tooltipField: 'tgtCostTitle',
      // valueFormatter: formatString,
      singleClickEdit: true,
      editable: this.isEditable,
      cellEditor: 'agLargeTextCellEditor',
      cellEditorParams: {
        maxLength: '255',
        cols: '40',
        rows: '5'
      },
      width: 500,
      cellStyle: cellStyle2,
      valueSetter: params => {
        params.data.tgtCostTitle = params.newValue ? params.newValue.trim() : params.newValue;
        return params.data.tgtCostTitle
      },
      // valueSetter: params => {
      //   params.data.tgtCostTitle = params.newValue.substr(0, 255);
      // },
    };
    this.domLayout = 'autoHeight';

    this.frameworkComponents = {
      doublingEditor: DoublingEditorComponent,
      NumericEditor: NumericEditorComponent,
    };
  }

  onGridOptionBSizeChanged(params) {
    this.optionBCostGridApi = params.api;
    this.optionBCostGridApi.sizeColumnsToFit();
  }

  onCellClicked(event) {
    this.sharedService.invokeFirstComponentFunction.subscribe((data) => {
      this.calSavingsReference();
      if (data.CostSavingDetailId != null) {
        this.hasUnsavedChanges = true;
        this.isChangeinOptBGrid = true;
        if (data.SolutionId == MSolutionType.OptionB) {
          if (this.arrayOptBGridData.filter(x => x.CostSavingDetailId == data.CostSavingDetailId && !x.IsActive).length == 0) {
            this.fillGridDataInArray(this.arrayDelOptBGridData, data, data.SolutionId, false);
          }
        }
      }
    });
  }

  onCellValueChanged(params) {
    this.hasUnsavedChanges = true;
    this.isChangeinOptBGrid = true;
    if (params.oldValue != params.newValue) {
      params.data.IsAction = true;
      this.optionBCostGridApi.expandAll();
    }

    if (params.column.colDef.field != "tgtCostTitle" && params.column.colDef.field != "CostType") {
      this.calSavingsReference();
    }
  }

  fillRemarks(event?: any) {
    this.hasUnsavedChanges = true;
  }

  calSavingsReference() {
    this.arraySavNRefCal = [];
    let optBOneTimeCostTotal = 0;

    this.optionBCostGridApi.forEachNode((rowNode, index) => {
      rowNode['IsEditable'] = this.isEditable;
      if (index == 0 && rowNode.aggData != undefined && rowNode.aggData.Total != undefined) {
        optBOneTimeCostTotal = parseFloat(rowNode.aggData.Total);
      }
    });

    let optBRowData = [];
    this.optionBCostGridApi.forEachLeafNode((rowNodeTar, indexRef) => {
      if (rowNodeTar.data.tgtCostHeader == this.recurringExpHeaderName
        && rowNodeTar.data.CostType.toLowerCase() != "Please select".toLowerCase()) {
        optBRowData.push({ 'Total': rowNodeTar.data.Total, 'AffectedUnits': parseInt(rowNodeTar.data.AffectedUnits) >= 0 ? parseInt(rowNodeTar.data.AffectedUnits) : 1 });
      }
    });

    if (optBOneTimeCostTotal > 0 || optBRowData.length > 0) {

      //Add Ref scenario - Option A Total column data
      this.arraySavNRefCal.push(parseFloat(this.RefOneTimeCostTotal) - optBOneTimeCostTotal);

      //Calculate Ref scenario, Option A Scenario Recurring expense data
      if (this.refRowData.length == optBRowData.length) {
        for (let i = 0; i < this.refRowData.length; i++) {
          for (let j = 0; j < optBRowData.length; j++) {
            if (i == j && optBRowData[i].AffectedUnits != null) {
              this.arraySavNRefCal.push((this.refRowData[i].RefRExpTotal - optBRowData[i].Total) * parseInt(optBRowData[i].AffectedUnits));
              break;
            }
          }
        }
      } else if (this.refRowData.length > optBRowData.length) {
        for (let i = 0; i < this.refRowData.length; i++) {
          if (i > (optBRowData.length - 1)) {
            this.arraySavNRefCal.push((this.refRowData[i].RefRExpTotal - 0) * 1);
          } else {
            for (let j = 0; j < optBRowData.length; j++) {
              if (i == j && optBRowData[i].AffectedUnits != null) {
                this.arraySavNRefCal.push((this.refRowData[i].RefRExpTotal - optBRowData[i].Total) * parseInt(optBRowData[i].AffectedUnits));
                break;
              }
            }
          }
        }
      } else if (optBRowData.length > this.refRowData.length) {
        for (let j = 0; j < optBRowData.length; j++) {
          if (j > (this.refRowData.length - 1)) {
            this.arraySavNRefCal.push((0 - optBRowData[j].Total) * parseInt(optBRowData[j].AffectedUnits));
          } else {
            for (let i = 0; i < this.refRowData.length; i++) {
              if (i == j && optBRowData[i].AffectedUnits != null) {
                this.arraySavNRefCal.push((this.refRowData[i].RefRExpTotal - optBRowData[i].Total) * parseInt(optBRowData[i].AffectedUnits));
                break;
              }
            }
          }
        }
      }
    }
    let arraySum = 0;
    if (this.arraySavNRefCal.length == 1) {
      arraySum = this.arraySavNRefCal[0];
    } else {
      arraySum = Number((this.arraySavNRefCal.reduce((acc, cur) => acc + Number(cur), 0)).toFixed(2));
    }
    this.savingsVSreferenceValue = new Intl.NumberFormat(countryCode).format(arraySum);
  }

  //Option A ag-Grid
  onGridOptionBCostReady(params: any) {
    this.optionBCostGridApi = params.api;
    setTimeout(() => {
      this.optionBCostGridApi.expandAll();
      this.calSavingsReference();
    }, 1000);
  }

  bindOptionBGridData() {
    //Get Reference Scenario data for Savings versus reference scenario calculation
    this.CostsavingdetailsService.getCostSavingByIdeaNSolutionId({ 'ideaId': this.ideaId, 'solutionId': MSolutionType.ReferenceScenario, 'userId': this.userInOrg.UserId }).subscribe(
      (response) => {
        let responseData;
        responseData = response;
        this.refRowData = [];
        if (responseData.Data.CostSaving.length > 0) {
          responseData.Data.CostSaving.forEach(function (value, key) {
            if (value.ExpenseTypeId == MExpenseType['One time costs/ Process costs']) {
              this.RefOneTimeCostTotal = this.RefOneTimeCostTotal + value.TotalCostPerUnit;
            } else {
              this.refRowData.push({ 'RefRExpTotal': value.TotalCostPerUnit });
            }
          }.bind(this));
        }
      });

    //Get Option B Ag-Grid Data
    this.CostsavingdetailsService.getCostSavingByIdeaNSolutionId({ 'ideaId': this.ideaId, 'solutionId': MSolutionType.OptionB, 'userId': this.userInOrg.UserId }).subscribe(
      (response: any) => {
        let errorMsgeFromBack = response.Data.Message;
        if (response.StatusCode == 200) {
          let responseData;
          responseData = response;
          if (responseData.Data.CostSaving.length > 0) {
            this.optionBCostRowData = [];
            if (responseData.Data.CostSaving.filter(x => x.ExpenseTypeId == MExpenseType['One time costs/ Process costs']).length > 0 && responseData.Data.CostSaving.filter(x => x.ExpenseTypeId == MExpenseType['Recurring Expenses']).length > 0) {
              this.optionBCostRowData = this.bindoptionBCostAgGridData(response);
            } else {
              if (responseData.Data.CostSaving.filter(x => x.ExpenseTypeId == MExpenseType['One time costs/ Process costs']).length > 0) {
                this.optionBCostRowData = this.optionBCostRowData.concat(this.bindoptionBCostAgGridData(response));
              } else {
                this.optionBCostRowData.push({ agGridId: "optionACostSavingGrid", CostSavingDetailId: null, tgtCostHeader: 'One time costs/ Process costs', tgtCostTitle: 'Add title', CostType: 'Please Select', LabourRate: null, Effort: null, TotalEffort: null, CostsUnit: null, Total: null, AffectedUnits: null, TotalCostAcc: null, IsAction: null });
              }

              if (responseData.Data.CostSaving.filter(x => x.ExpenseTypeId == MExpenseType['Recurring Expenses']).length > 0) {
                this.optionBCostRowData = this.optionBCostRowData.concat(this.bindoptionBCostAgGridData(response));
              } else {
                this.optionBCostRowData.push({ agGridId: "optionACostSavingGrid", CostSavingDetailId: null, tgtCostHeader: 'Recurring Expenses', tgtCostTitle: 'Add title', CostType: 'Please Select', LabourRate: null, Effort: null, TotalEffort: null, CostsUnit: null, Total: null, AffectedUnits: null, TotalCostAcc: null, IsAction: null });
              }
            }
          } else {
            this.optionBCostRowData = [
              { agGridId: "optionBCostSavingGrid", CostSavingDetailId: null, tgtCostHeader: 'One time costs/ Process costs', tgtCostTitle: 'Add title', CostType: 'Please Select', LabourRate: null, Effort: null, TotalEffort: null, CostsUnit: null, Total: null, AffectedUnits: null, TotalCostAcc: null, IsAction: null },
              { agGridId: "optionBCostSavingGrid", CostSavingDetailId: null, tgtCostHeader: 'Recurring Expenses', tgtCostTitle: 'Add title', CostType: 'Please Select', LabourRate: null, Effort: null, TotalEffort: null, CostsUnit: null, Total: null, AffectedUnits: null, TotalCostAcc: null, IsAction: null },
            ];
          }

          //Bind Remark data
          if (responseData.Data.Remarks != null) {
            this.RemarksId = responseData.Data.Remarks.RemarkId;
            this.Remarks = responseData.Data.Remarks.Remark;
            this.isChangeRemarks = responseData.Data.Remarks.Remark;
          } else {
            this.RemarksId = null;
            this.Remarks = null;
            this.isChangeRemarks = null;
          }

          //Load Ag-Grid
          this.loadAgGrid();
        }
        else {
          //Show errorCode and errorMessage in the UI
          let errorContainer = [
            { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer)
        }
      }, (error) => {
        // this.sharedService.getErrorMessage(error);
        //Show errorCode and errorMessage in the UI
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
      }
    )
  }

  bindoptionBCostAgGridData(obj) {
    let dataBind = {};
    let optBCostRowData = [];
    this.optionBCostRowData = obj;

    this.optionBCostRowData.Data.CostSaving.forEach(function (value, key) {
      if (value.SolutionId == MSolutionType.OptionB) {
        dataBind = {
          IdeaId: this.ideaId,
          SolutionId: value.SolutionId,
          agGridId: "tgtCostSavingGrid",
          CostSavingDetailId: value.CostSavingDetailId,
          tgtCostHeader: value.ExpenseTypeId == MExpenseType['One time costs/ Process costs'] ? this.oneTimeCostHeaderName : this.recurringExpHeaderName,
          tgtCostTitle: value.Title,
          CostType: this.costType.filter(x => x.CostTypeId == value.CostTypeId)[0].CostTypeTitle,
          LabourRate: value.LabourRate,
          Effort: value.Efforts,
          TotalEffort: value.TotalEfforts,
          CostsUnit: value.CostPerUnit,
          Total: value.TotalCostPerUnit,
          AffectedUnits: value.AffectedUnits,
          TotalCostAcc: value.TotalCostAcc,
          IsActive: value.IsActive,
          IsAction: null
        }
      }
      optBCostRowData.push(dataBind);
    }.bind(this));
    return optBCostRowData;
  }

  
  concatDelNAddUpdateData(optBAgGridData) {
    if (this.arrayDelOptBGridData.length == 0) {
      return [optBAgGridData];
    }
    else if (this.arrayDelOptBGridData.length > 0) {
      if (optBAgGridData != undefined) {
        optBAgGridData.CostSaving = optBAgGridData.CostSaving.concat(this.arrayDelOptBGridData);
        return [optBAgGridData];
      }
    }
  }

  submit(event?: any) {

    this.submitted = true;
    let optBAgGridData: any;
    let formResponse = null;

    
    if (this.isChangeinOptBGrid) {
      optBAgGridData = this.getOptionBGridData();
    }
    
    if (!this.isChangeinOptBGrid && this.Remarks != null && (this.isChangeRemarks != this.Remarks)) {
      optBAgGridData = this.getRemarkData();
    }
    if (optBAgGridData != 'error') {
      if (optBAgGridData == undefined && (this.isChangeRemarks == this.Remarks)) {
        if (event != undefined) {
          this.router.navigate(['/manageIdea'])
        }
      } else {
        formResponse = this.postFormData(event, this.concatDelNAddUpdateData(optBAgGridData));
      }
    }
    return formResponse;
  }

  
  getOptionBGridData() {
    let error = [];
    let optionBGridData: any;
    let regex = new RegExp(/\^s*$/);
    this.arrayOptBGridData = [];
    this.optionBCostGridApi.forEachLeafNode((rowNode, index) => {
      if (rowNode.data.IsAction != null) {
        if (optionBGridData != 'error') {
          if (regex.test(rowNode.data.tgtCostTitle) || rowNode.data.tgtCostTitle == undefined ||
            rowNode.data.tgtCostTitle == "" || rowNode.data.tgtCostTitle.toLowerCase() == "Add Title".toLowerCase()) {
            optionBGridData = 'error';
            error.push({ "Title": messages.costAndSaving.fillOptBCostTypeValidationMessage })
            this.arrayOptBGridData = [];
          }
          if ((rowNode.data.AffectedUnits == "" || rowNode.data.AffectedUnits == null) && rowNode.data.AffectedUnits != 0
            && rowNode.data.tgtCostHeader == 'Recurring Expenses') {
            optionBGridData = 'error';
            error.push({ "Affected Units": messages.costAndSaving.fillOptBCostTypeValidationMessage })
            this.arrayOptBGridData = [];
          }
          else {
            this.fillGridDataInArray(this.arrayOptBGridData, rowNode.data, MSolutionType.OptionB, true);
          }
        }
      }
    });

    if (optionBGridData != 'error') {
      optionBGridData = this.getAgGridData(this.arrayOptBGridData, MSolutionType.OptionB);
    }
    if (error.length > 0) {
      this.openAlertDialog(error)
    }
    return optionBGridData;
  }

  
  getRemarkData() {
    let remarksData: any;
    if ((this.isChangeRemarks != this.Remarks.trim())) {
      remarksData = this.getAgGridData(this.arrayOptBGridData, MSolutionType.OptionB);
    }
    return remarksData;
  }

  
  fillGridDataInArray(objCostSavingData, objData, solutionId, isActive) {
    objCostSavingData.push({
      CostSavingDetailId: objData.CostSavingDetailId ?? 0,
      IdeaId: this.ideaId,
      SolutionId: solutionId,
      Title: objData.tgtCostTitle,
      CostTypeId: objData.CostType.toLowerCase() == "Please select".toLowerCase() ? 0 : this.costType.filter(x => x.CostTypeTitle == objData.CostType)[0].CostTypeId,
      ExpenseTypeId: objData.tgtCostHeader == this.oneTimeCostHeaderName ? MExpenseType['One time costs/ Process costs'] : MExpenseType['Recurring Expenses'],
      LabourRate: objData.LabourRate == null ? null : parseFloat(objData.LabourRate),
      Efforts: objData.Effort == null ? null : parseFloat(objData.Effort),
      TotalEfforts: objData.TotalEffort == null ? null : parseFloat(objData.TotalEffort),
      CostPerUnit: objData.CostsUnit == null ? null : parseFloat(objData.CostsUnit),
      TotalCostPerUnit: objData.Total == null ? null : parseFloat(objData.Total),
      AffectedUnits: objData.AffectedUnits == null ? null : parseInt(objData.AffectedUnits),
      TotalCostAcc: objData.TotalCostAcc == null ? null : parseFloat(objData.TotalCostAcc),
      IsActive: isActive,
      CreatedBy: this.userInOrg.UserId,
      ModifiedBy: this.userInOrg.UserId,
    })
  }

  
  getAgGridData(costSavingGridData, solutionType) {
    this.formData = {
      CostSaving: costSavingGridData,
      IdeaId: this.ideaId,
      SolutionId: solutionType,
      UserId: this.userInOrg.UserId,
      BusinessAreaId: this.businessAreaId,
      BusinessLineId: this.businessLineId,
      Remarks:
        this.isChangeRemarks == this.Remarks ? null : {
          RemarkId: this.RemarksId ?? 0,
          IdeaId: this.ideaId, SolutionId: MSolutionType.OptionB, Remark: this.isChangeRemarks != this.Remarks ? this.Remarks.trim() : null, RemarkTypeId: EnumRemarkType.CostSaving,
          IsActive: true, CreatedBy: this.userInOrg.UserId, ModifiedBy: this.userInOrg.UserId
        }
    }
    return this.formData;
  }

  
  postFormData(event, postOptioAGridData) {
    let response = this.CostsavingdetailsService.postCostSavingDetailData(postOptioAGridData).toPromise().then(
      (response) => {
        this.responsePost = response
        let successCode = this.responsePost.StatusCode;
        let errorCode = this.responsePost.Data.ErrorCode;
        let errorMsgeFromBack = this.responsePost.Data.Message;

        //Check if successCode is ok i.e 200
        if (successCode == 200) {
          //check if errorCode in the response is 0 then everythig is fine.
          if (errorCode == 0) {
            this.ToasterService.notify(serverMessage.dataSaveMessage, "success");
            this.hasUnsavedChanges = false;
            if (event != undefined) {
              this.router.navigate(['/manageIdea'])
            }
            return true;
          }
          //If the error code in the resposne is not 0, then display the error in UI.
          else {
            //Show errorCode and errorMessage in the UI
            let errorContainer = [
              { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
              { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
            ]
            this.openAlertDialog(errorContainer)
            this.submitted = false;
            return false;

          }
        }
        //Going in else means that success code is not. ie. Http Status from server is not ok.
        else {
          //Show errorCode and errorMessage in the UI
          let errorContainer = [
            { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
            { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
          ]
          this.openAlertDialog(errorContainer)
          this.submitted = false;
          return false;
        }
      }, (error) => {
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
        this.submitted = false;
        return false;
      })
    return response;
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error });
    this.submitted = false;
  }

  displayErrorMessage(errorType, errorMessage) {
    //If error come, Clear data from Reference and Target array
    this.arrayOptBGridData = [];

    //If error come, Display error message
    let alertBoxError = [];
    if (errorType == 1) {
      alertBoxError.push({ "Cost Type": errorMessage })
    } else {
      alertBoxError.push({ "Title": errorMessage })
      alertBoxError.push({ "Cost Type": errorMessage })
    }

    this.dialog.open(AlertDialogComponent, { data: alertBoxError })
    this.submitted = false
  }

  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.router.navigate(['/manageIdea'])
  }

  onClickBack() {
    this.menuService.onClickNextAndBack("back")

  }
  onClickNext() {
    this.menuService.onClickNextAndBack("next")
  }
}

function cellStyle(params) {
  let regex = new RegExp(/\^s*$/);
  if (params.data != undefined) {
    return params.data.CostType.toLowerCase() == 'Please Select'.toLowerCase() &&
      ((!regex.test(params.data.tgtCostTitle) && params.data.tgtCostTitle !== 'Add title' && params.data.tgtCostTitle !== "")
        || ((params.data.AffectedUnits != null && params.data.AffectedUnits != ""))) ? { borderLeft: '5px solid #a94442' } : { borderLeft: '' };
  }
}
function cellStyle1(params) {
  let regex = new RegExp(/\^s*$/);
  if (params.data != undefined) {
    return !regex.test(params.data.tgtCostTitle) && params.data.tgtCostHeader == "Recurring Expenses"
    && (params.data.tgtCostTitle !== 'Add title' && params.data.tgtCostTitle !== "") && (params.data.AffectedUnits !== 0 && (params.data.AffectedUnits == null || params.data.AffectedUnits == "")) ? { borderLeft: '5px solid #a94442' } : { borderLeft: '' };

  }
}
function cellStyle2(params) {
  let regex = new RegExp(/\^s*$/);
  if (params.data != undefined) {

    return (regex.test(params.data.tgtCostTitle) || params.data.tgtCostTitle == 'Add title' || params.data.tgtCostTitle == "") && (
      (params.data.AffectedUnits != null && params.data.AffectedUnits != "")) ? { borderLeft: '5px solid #a94442' } : { borderLeft: '' };

  }
}

function CurrencyCellRenderer(params: any) {
  if (params.value == 0)
    return params.value;

  return params.value == null || params.value == undefined || params.value == "" ? null : new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(2)));
};

function funTotalEffort(params: any) {
  if (params.data.LabourRate != undefined && params.data.Effort != undefined) {
    params.data.TotalEffort = parseFloat(params.data.LabourRate) * parseFloat(params.data.Effort)
    return parseFloat(params.data.TotalEffort).toFixed(2);
  }
  //return;
};

function funTotal(params: any) {
  if (params.data.TotalEffort != undefined && params.data.CostsUnit == undefined) {
    if (params.data.LabourRate == null || params.data.Effort == null) {
      params.data.Total = params.data.CostsUnit == null || isNaN(params.data.CostsUnit) ? null : parseFloat(params.data.CostsUnit)
      return params.data.Total
    } else {
      params.data.Total = parseFloat(params.data.CostsUnit ?? 0) + parseFloat(params.data.TotalEffort)
      return parseFloat(params.data.Total).toFixed(2);
    }
  }

  if (params.data.CostsUnit != undefined) {
    if (params.data.LabourRate == null || params.data.Effort == null) {
      params.data.Total = params.data.CostsUnit == null || isNaN(params.data.CostsUnit) ? null : parseFloat(params.data.CostsUnit)
      return params.data.Total
    } else {
      params.data.Total = parseFloat(params.data.CostsUnit ?? 0) + parseFloat(params.data.TotalEffort)
      return parseFloat(params.data.Total).toFixed(2);
    }
  }
  //return;
};

function funTotalCost(params: any) {
  if (parseInt(params.data.AffectedUnits) != 0 && params.data.tgtCostHeader == "One time costs/ Process costs" && (params.data.AffectedUnits == undefined || params.data.AffectedUnits == null ||
    params.data.AffectedUnits == "" || isNaN(params.data.AffectedUnits))) {
    return params.data.Total;
  }
  if (parseInt(params.data.AffectedUnits) != 0 && (params.data.AffectedUnits == undefined || params.data.AffectedUnits == null ||
    params.data.AffectedUnits == "" || isNaN(params.data.AffectedUnits)) && params.data.tgtCostHeader == "Recurring Expenses") {
    params.data.TotalCostAcc = null;
    return params.data.TotalCostAcc;
  } else {
    params.data.TotalCostAcc = parseInt(params.data.AffectedUnits) * parseFloat(params.data.Total ?? 0);
    if (params.data.TotalCostAcc == 0) {
      return params.data.TotalCostAcc;
    }
    return parseFloat(params.data.TotalCostAcc).toFixed(2);
  }
}